module.exports = __webpack_public_path__ + "img/Support.c04c41b0.svg";